export default "__VITE_ASSET__BFRptwDG__"